import '@fontsource/source-code-pro';

import { Modal, Slide } from '@mui/material';
import SvgWindow95 from 'assets/animator/window95.inline.svg';
import TextCodeFor from 'components/material-ui/TextCodeFor';
import TextController from 'components/material-ui/TextController';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect } from 'react';
import { isBrowser } from 'utils/helper';

export default function ModalCode({ isOpen, onClose, children, ...props }) {
	const { t } = useTranslation();

	useEffect(() => {
		if(isBrowser && isOpen) {
			document.addEventListener('keydown', handleKeydown);

			return () => {
				document.removeEventListener('keydown', handleKeydown);
			};
		}
	}, [isOpen]);

	const handleKeydown = event => {
		if(event?.key === 't' || event?.key === 'T') {
			onClose(event);
		}
	};

	return (
		<Modal open={isOpen} {...props}>
			<div data-cy='ModalCode' className='outline-none absolute top-50/100 left-50/100 -transform-translate-1/2 w-88/100 sm:w-60/100 border-4 border-green-2'>
				<div>
					<div className='flex items-center justify-between bg-green-2 h-16 pb-02'>
						<p className='text-09 text-light mr-05 ml-02'>{t('modal.os.title')}</p>
						<div className='w-full h-full flex flex-col items-between justify-evenly'>
							<div className='w-full bg-light' style={{ height: '4px' }} />
							<div className='w-full bg-light' style={{ height: '4px' }} />
						</div>
						<div className='ml-03 mr-02' onClick={onClose}>
							<SvgWindow95 />
						</div>
					</div>

					<div className='bg-green-3'>
						<Slide direction='up' in={isOpen} mountOnEnter unmountOnExit>
							<div className='text-09 text-light p-10 pb-20'>
								<TextController index={0} className='mb-20'>
									<TextCodeFor tw='leading-12' showCaretDuringDelay delay={1200}>{t('modal.os.terminal.1')}</TextCodeFor>
									<TextCodeFor tw='leading-12'>{t('modal.os.terminal.2')}</TextCodeFor>
									<TextCodeFor tw='leading-12' delayCaretHide={1200}>{t('modal.os.terminal.3')}</TextCodeFor>
								</TextController>
								{children}
							</div>
						</Slide>
						<p className='text-07 mx-05 text-light'>{t('modal.os.footer')}</p>
					</div>
				</div>
			</div>
		</Modal>
	);
}
